const DEFAULT_EXPIRY_SKEW_MS = 30_000;

// True when the SAS `se` (signed expiry) parameter is past or within `skewMs`.
// Missing or unparsable input counts as not expired — a pointless retry is harmless.
export const isSasUrlExpired = (url: string, skewMs = DEFAULT_EXPIRY_SKEW_MS): boolean => {
  try {
    const signedExpiry = new URL(url).searchParams.get("se");
    if (!signedExpiry) {
      return false;
    }
    const expiryMs = Date.parse(signedExpiry);
    if (Number.isNaN(expiryMs)) {
      return false;
    }
    return expiryMs - skewMs <= Date.now();
  } catch {
    return false;
  }
};
